import { render, staticRenderFns } from "./EditCurrency.vue?vue&type=template&id=88599358&"
import script from "./EditCurrency.vue?vue&type=script&lang=js&"
export * from "./EditCurrency.vue?vue&type=script&lang=js&"
import style0 from "./EditCurrency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports